export default "__VITE_ASSET__DsuFA8_v__"